
import Navigation from './Navigation';

const Header = () => {
    return (
        <header id="main-header">
            <Navigation />
        </header>
    );
};

export default Header;